// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__XX8rE","label":"CategoryService_label__2l0dZ","location":"CategoryService_location__1tAlv"};